import { Heading, Stack, useText } from "@sveabank/cc-common";
import Image from "../../../components/image";
import type { SelectedCreditProduct } from "../../../types/product";
import { productImages } from "../helpers";

type Props = {
	product: SelectedCreditProduct;
};

const CreditProductInfo = ({ product }: Props) => {
	const [t, texts] = useText();

	const productImage = productImages[product.sku];
	const addonTexts = texts.addons[product.sku];
	const title = "title" in addonTexts ? t(addonTexts.title) : "";

	return (
		<Stack direction="row" align="start" gap={4}>
			{product.productDefinitionId === "CREDITCARD" && productImage && (
				<div className="tablet:block hidden w-[139px]">
					<Image imageSrc={productImage} altText="credit-card" />
				</div>
			)}
			<Heading.H4>{title}</Heading.H4>
		</Stack>
	);
};

export default CreditProductInfo;
